const serviceUrl = `${__configuration.apiUrl}/massia/motifs-depreciation-stock`;

export default class MotifsDepreciationStockService {
    static $inject = ['$http'];

    constructor($http) {
        this.$http = $http;
    }

    async getMotifsDepreciationStock(filters, sorts, pagination) {
        const res = await this.$http.get(serviceUrl, {
            params: {
                filters: JSON.stringify(filters || []),
                sorts: JSON.stringify(sorts || []),
                pagination: JSON.stringify(pagination || {})
            }
        });

        return res.data;
    }

    async deleteMotifDepreciationStockById(id) {
        const url = `${serviceUrl}/${id}`;
        return this.$http.delete(url);
    }

    async getMotifDepreciationStockById(id) {
        const url = `${serviceUrl}/${id}`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async createMotifDepreciationStock(selectedMotifDepreciationStock) {
        const data = {
            code: selectedMotifDepreciationStock.code,
            libelle: selectedMotifDepreciationStock.libelle
        };
        const result = await this.$http.post(serviceUrl, data);
        return result.data;
    }

    async updateMotifDepreciationStock(selectedMotifDepreciationStock) {
        const data = {
            id: selectedMotifDepreciationStock.id,
            code: selectedMotifDepreciationStock.code,
            libelle: selectedMotifDepreciationStock.libelle
        };
        const url = `${serviceUrl}/${data.id}`;
        return this.$http.put(url, data);
    }

    async codeExists(code) {
        const url = `${serviceUrl}/code-unicity/${code}`;
        const result = await this.$http.get(url);
        return result.data;
    }
}
